import React from "react";
import { useTranslation } from "react-i18next";
import { Modal } from "react-bootstrap";

const EdiFiscalModal = ({ show, handleHide, title, text, confirmEdiFiscal }) => {
  const { t: translator } = useTranslation();

  return (
    <Modal show={show} onHide={handleHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>{text}</p>
      </Modal.Body>
      <Modal.Footer>
        <button
          type="button"
          className="btn btn-outline-secondary"
          data-dismiss="modal"
          onClick={handleHide}
        >
          {translator("General-Close")}
        </button>
        <button
          onClick={confirmEdiFiscal}
          type="button"
          className="btn btn-primary"
        >
          {translator("BtnSend-Banquap-Fiscal")}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default EdiFiscalModal;
